import { ErrorHandlerError } from "./ErrorHandlerError.interface"

export class SurveyError extends Error implements ErrorHandlerError {
	public errorMessage: string
	public errorCode?: string
	public httpStatus: number
	static SURVEYS_FETCH_ERROR = "There was an error fetching the surveys"
	static SURVEY_CREATE_ERROR = "There was an error creating the survey"
	static SURVEY_UPDATE_ERROR = "There was an error updating the survey"
	static SURVEY_DELETE_ERROR = "There was an error deleting the survey"
	static SURVEYS_FETCH_USERS_ERROR = "There was an error fetching users by autocomplete"
	static SURVEY_SECTIONS_FETCH_ERROR = "There was an error fetching the survey sections"
	static SURVEY_SECTION_CREATE_ERROR = "There was an error creating the survey section"
	static SURVEY_SECTION_UPDATE_ERROR = "There was an error updating the survey section"
	static SURVEY_SECTION_DELETE_ERROR = "There was an error deleting the survey section"
	static SURVEYS_EXPORT_ERROR = "There was an error exporting the surveys"

	constructor({ errorMessage, errorCode, httpStatus }: ErrorHandlerError) {
		super(errorMessage)
		this.errorMessage = errorMessage
		this.errorCode = errorCode
		this.httpStatus = httpStatus
		this.name = "SurveyError"
	}
}
